<template>
    <div class="mb-3">
        <h3 v-if="purchase.contract.supplementary_agreements && ((purchase.contract.supplementary_agreements.length === 0 && $store.getters.isLoggedIn && purchase.flags.is_customer) || purchase.contract.supplementary_agreements.length > 0)" id="supplementary_agreements" class="atmo-hash-jump-point">
            Дополнительные соглашения
        </h3>
        <div v-if="purchase.contract.supplementary_agreements.length > 0" class="accordion" role="tablist">
            <component
                :is="supplementaryAgreementComponent(supplementaryAgreement)"
                :pivc="pivc"
                v-for="(supplementaryAgreement, key) in purchase.contract.supplementary_agreements"
                :key="`supplementary-agreement-${key}`"
                :purchase="purchase"
                :supplementary-agreement="supplementaryAgreement"
                :visible="purchase.contract.latest_supplementary_agreement_id === supplementaryAgreement.id"
                @refresh="refresh(null)" />
        </div>
        <private-fl44-contract-send-supplementary-agreement-customer-block :pivc="pivc" :purchase="purchase" @refresh="refresh($event)" />
    </div>
</template>

<script>
import Fl44ContractSupplementaryAgreementRegularItem from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-regular-item.vue';
import Fl44ContractSupplementaryAgreementTerminationItem from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-item.vue';
import PrivateCustomerFl44ContractSupplementaryAgreementCreateBlock from '@/components/products/fl44/partials/private-customer-fl44-contract-supplementary-agreement-create-block.vue';

export default {
    name: 'fl44-contract-supplementary-agreements-block',
    components: {
        PrivateFl44ContractSendSupplementaryAgreementCustomerBlock: PrivateCustomerFl44ContractSupplementaryAgreementCreateBlock
    },
    props: {
        purchase: {
            type: Object
        },
        pivc: {
            type: Object
        }
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        supplementaryAgreementComponent(supplementaryAgreement) {
            switch (supplementaryAgreement.type.id) {
                case 'termination':
                    return Fl44ContractSupplementaryAgreementTerminationItem;
                default:
                    return Fl44ContractSupplementaryAgreementRegularItem;
            }
        }
    }
};
</script>
